"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadonlyNetworksProvider = exports.useReadonlyNetworks = void 0;
var context_1 = require("./context");
Object.defineProperty(exports, "useReadonlyNetworks", { enumerable: true, get: function () { return context_1.useReadonlyNetworks; } });
var provider_1 = require("./provider");
Object.defineProperty(exports, "ReadonlyNetworksProvider", { enumerable: true, get: function () { return provider_1.ReadonlyNetworksProvider; } });
//# sourceMappingURL=index.js.map